import { Form, Formik } from "formik";

import { postApi, putApi } from "../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
} from "../../utils/toastify-message/ToastifyMessage";

import Button from "../../components/common/button/Button";
import Input from "../../components/common/inputs/Input";
import AdminFormLayout from "../../components/common/form-layout/AdminFormLayout";
import Select from "../../components/common/inputs/Select";
import { useLocation, useNavigate } from "react-router";
import VendorStatusModal from "../../components/common/modals/vendor-status-modal/VendorStatusModal";
import { useRef } from "react";
import { publicImageProps } from "../../services/config";

export default function VendorStores() {
  const location = useLocation();
  const navigate = useNavigate();

  const formHandler = async (values) => {
    const path = "api/vendorStores";
    const body = { ...values, selectedBooth: values.selectedBooth === "1" };
    try {
      if (location.state) {
        await putApi({ path: path + "/" + location.state._id, body });
      } else {
        await postApi({ path, body });
      }
      successMessage("عملیات با موفقیت انجام شد");
      navigate(`/vendor-stores-list`);
    } catch (error) {
      console.log(error);
      errorMessage(error?.response?.data?.errors[0]?.message);
    }
  };

  const vendorRef = useRef();

  const chnageStatus = () => {
    vendorRef.current.showModal();
  };

  return (
    <>
      <VendorStatusModal
        ref={vendorRef}
        data={location?.state}
        // reGetData={getVendor}
        isGet={false}
      />
      <AdminFormLayout title={location?.state ? "ویرایش غرفه" : "افزودن غرفه"} description="اطلاعات تماس، مشخصات غرفه و وضعیت نمایش آن را تنظیم کنید.">
        <div className="flex flex-wrap items-center justify-end gap-3">

          {location?.state ? (
            <Button
              onClick={chnageStatus}
              text={"تغییروضعیت"}
              color={"primary"}
              type="button"
            />
          ) : null}
        </div>

        {location?.state?.mainImage ? (
          <div className="mt-5">
            <h3 className="mb-5">تصویر غرفه</h3>
            <div className="py-4 shadow rounded-xl">
              <img
                className="w-full max-w-sm h-auto rounded-xl object-contain mx-auto"
                {...publicImageProps(location?.state.mainImage, { vendor: true, variant: "thumb_" })}
              />
            </div>
          </div>
        ) : null}

        <Formik
          enableReinitialize
          initialValues={{
            mobile: location?.state?.mobile || "",
            name: location?.state?.name || "",
            address: location?.state?.address || "",
            description: location?.state?.description || "",
            vendorType: location?.state?.vendorType || "candle",
            selectedBooth: location?.state?.selectedBooth ? "1" : "0",
          }}
          onSubmit={formHandler}
        >
          {(formik) => (
            <Form>
              <div className="grid gap-6 mb-6 md:grid-cols-2 mt-4">
                <Input name="name" label={"نام"} placeholder={"نام"} />
                <Input name="mobile" label={"موبایل"} placeholder={"موبایل"} />
                <Input name="address" label={"آدرس"} placeholder={"آدرس"} />
                <Input
                  name="description"
                  label={"توضیحات"}
                  placeholder={"توضیحات"}
                />
                <Select
                  name="vendorType"
                  placeholder="نوع غرفه"
                  label="نوع غرفه"
                >
                  <option value={""}>انتخاب نوع غرفه</option>
                  <option value={"candle"}>شمع سازی</option>
                  <option value={"mold"}>قالب سازی</option>
                </Select>
                <Select
                  name="selectedBooth"
                  placeholder="غرفه منتخب"
                  label="غرفه منتخب"
                >
                  <option value={"0"}>خیر</option>
                  <option value={"1"}>بله</option>
                </Select>
              </div>
              <div className="admin-form-actions">
<Button disabled={formik.isSubmitting} loading={formik.isSubmitting} type="submit"
                text={location?.state ? "ویرایش" : "افزودن"}
                color={"success"}
              />
                <button type="button" className="admin-form-cancel" onClick={() => navigate("/vendor-stores-list")}>انصراف</button>
              </div>
            </Form>
          )}
        </Formik>
      </AdminFormLayout>
    </>
  );
}
